import React from "react";
import { Helmet } from "react-helmet-async";

import ContactHero from "../components/contact/ContactHero";
import GlobalCta from "../components/global/GlobalCta";
import FujairahTextImage from "../components/truck-rental-fujairah/FujairahTextImage";
import FujairahTextSection from "../components/truck-rental-fujairah/FujairahTextSection";
import FujairahFaq from "../components/truck-rental-fujairah/FujairahFaq";
import VanRentalTable from "../components/van-rental-dubai/VanRentalTable";

import { chillerVanAlQuozSections } from "../components/chiller-van-al-quoz/chillerVanAlQuozSections";
import "../components/truck-rental-fujairah/truck-rental-fujairah.css";
import "../components/van-rental-dubai/van-rental-dubai.css";
import "../components/chiller-van/chiller-van.css";

const ChillerVanForRentInAlQuoz = () => {
  const renderSection = (section, index) => {
    switch (section.type) {
      case "cvq-hero":
        return (
          <ContactHero
            key={index}
            variant="chiller-van"
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      case "cvq-text-image":
        return (
          <FujairahTextImage
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
            image={section.image}
            imageAlt={section.imageAlt}
            reverse={section.reverse}
            altBg={section.altBg}
          />
        );

      case "cvq-text-only":
        return (
          <FujairahTextSection
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      case "cvq-table":
        return (
          <VanRentalTable
            key={index}
            title={section.title}
            description={section.description}
            intro={section.intro}
            columns={section.columns}
            rows={section.rows}
            notes={section.notes}
            background={section.background}
          />
        );

      case "cvq-faq":
        return (
          <FujairahFaq
            key={index}
            title={section.title}
            faqs={section.faqs}
          />
        );

      case "cta":
        return (
          <GlobalCta
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>Chiller Van Rental in Al Quoz | From AED 250/Day</title>
        <meta name="description" content="Chiller van rental in Al Quoz for central kitchens, bakeries and F&B distributors — vans sized for narrow industrial access, dispatched from two Dubai branches." />
        <link rel="canonical" href="https://chillerfleet.com/chiller-van-for-rent-in-al-quoz" />
        <meta property="og:title" content="Chiller Van Rental in Al Quoz | From AED 250/Day" />
        <meta property="og:description" content="Chiller van rental in Al Quoz for central kitchens, bakeries and F&B distributors — vans sized for narrow industrial access, dispatched from two Dubai branches." />
        <meta property="og:url" content="https://chillerfleet.com/chiller-van-for-rent-in-al-quoz" />
        <meta name="twitter:title" content="Chiller Van Rental in Al Quoz | From AED 250/Day" />
        <meta name="twitter:description" content="Chiller van rental in Al Quoz for central kitchens, bakeries and F&B distributors — vans sized for narrow industrial access, dispatched from two Dubai branches." />
      </Helmet>

      {chillerVanAlQuozSections.map(renderSection)}
    </>
  );
};

export default ChillerVanForRentInAlQuoz;
